<template>
    <div>
        <!-- @TODO: Add this to a reusable component -->
        <div class="text-center">
            <div class="logo-device text-center mb-6">
                <img :src="global.app.url + 'images/logo-device.svg'" alt="Options Desk O logo" title="Options Desk" />
            </div>

            <h1 class="text-xl uppercase font-semibold mb-5">Please login below</h1>
        </div>
        <!-- @ENDTODO -->

        <ValidationObserver v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(handleLogin)">
                <InputComponent
                    v-model="loginFormData.email"
                    type="email"
                    label="Email Address"
                    placeholder="Email Address"
                    show-success-status
                />

                <div class="mt-8">
                    <InputComponent
                        v-model="loginFormData.password"
                        name="password"
                        type="password"
                        rules="required"
                        label="Password"
                        autocomplete="current-password"
                        placeholder="Password"
                    />
                </div>

                <div class="mt-3 text-right">
                    <router-link :to="{ name: 'forgot-password' }" class="text-white">Forgot Password?</router-link>
                </div>

                <div class="mt-8">
                    <AlertComponent
                        :message="global.flashMessage.message"
                        :errors="global.flashMessage.errorList"
                        :color="global.flashMessage.color"
                    />
                </div>

                <div class="mt-8">
                    <ButtonComponent type="submit" color="primary" label="Login" :isLoading="isLoading" />
                </div>

                <div class="mt-5">
                    <router-link :to="{ name: 'register' }" class="button">Register</router-link>
                </div>
            </form>
        </ValidationObserver>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { ValidationObserver } from "vee-validate";
import InputComponent from "@components/inputs/InputComponent";
import ButtonComponent from "@components/buttons/ButtonComponent";
import AlertComponent from "@components/misc/AlertComponent";

export default {
    name: "LoginPage",
    components: {
        ValidationObserver,
        InputComponent,
        ButtonComponent,
        AlertComponent,
    },
    computed: {
        ...mapGetters(["global"]),
    },
    data: function () {
        return {
            isLoading: false,
            loginFormData: {
                email: "",
                password: "",
            },
        };
    },
    methods: {
        ...mapActions(["doLogin", "setGlobalFlashResponse", "resetGlobalFlashResponse"]),
        handleLogin() {
            this.resetGlobalFlashResponse(); // @TODO: Make this be actioned more dynamically without having to include it on a regular basis. Perhaps on Vue Router route change, clear the state
            this.isLoading = true;
            this.doLogin(this.loginFormData).then(
                (response) => {
                    if (response.data.role == "Admin") {
                        let adminDashboardUrl = this.$router.resolve({
                            name: "admin-dashboard",
                        });
                        window.location.replace(adminDashboardUrl.href);
                    } else {
                        this.isLoading = false;
                        this.$router.push({ name: "create-account", params: { step: 1 } });
                    }
                },
                (error) => {
                    this.isLoading = false;
                    if (error.response.data.message != "Your email address is not verified") {
                        this.setGlobalFlashResponse({
                            message: "There was a problem trying to log you in, please check your credentials.",
                        });
                    }
                }
            );
        },
    },
};
</script>
